import { NavLink, Outlet, useNavigate } from "react-router-dom";
import Header from "./../Header";
import Footer from "./../Footer";



const menuItems = [
  { to: "/consultant", label: "工作台", end: true },
  // { to: "/", label: "订单管理" },
  { to: "/consultant/schedule", label: "时间管理" },
  { to: "/consultant/clients", label: "来访者" },
  { to: "/consultant/messages", label: "系统消息" },
  { to: "/consultant/profile/setup", label: "资料设置" },
  { to: "/consultant/security", label: "账号安全" },
  { to: "/consultant/consultantDetail", label: "主页预览" },
  // { to: "/", label: "收益统计" },
];

export default function ConsultantLayout() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
    window.location.reload();
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Header />

      <div className="flex-1 px-4 py-8">
        <div className="max-w-7xl mx-auto grid grid-cols-12 gap-6">
          <aside className="col-span-12 md:col-span-3 bg-white rounded-2xl shadow p-4">
            <h2 className="text-xl font-bold mb-4 text-blue-600">
              咨询师中心
            </h2>

            <div className="flex flex-col gap-2">
              {menuItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.end}
                  className={({ isActive }) =>
                    `px-4 py-3 rounded-xl transition ${
                      isActive
                        ? "bg-blue-500 text-white"
                        : "hover:bg-blue-50 text-gray-700"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}

              <button
                onClick={handleLogout}
                className="mt-4 px-4 py-3 text-left text-red-500 hover:bg-red-50 rounded-xl"
              >
                退出登录
              </button>
            </div>
          </aside>

          <main className="col-span-12 md:col-span-9 bg-white rounded-2xl shadow p-6">
            <Outlet />
          </main>
        </div>
      </div>

      <Footer />
    </div>
  );
}